/*
 * ping-sample-web-react-todo-oidc
 *
 * theme.context.js
 *
 * Copyright (c) 2026 Ping Identity Corporation. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
import { createContext } from 'react';

/**
 * @function initTheme - Initialize the global theme based on user preference
 * @returns {Object} - Theme configuration object
 */
export function initTheme() {
  let theme;
  //const prefersDarkTheme = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const prefersDarkTheme = false;
  if (prefersDarkTheme) {
    document.body.classList.add('cstm_bg-dark', 'bg-dark');
    theme = {
      mode: 'dark',
      // CSS Classes
      bgClass: 'bg-dark',
      borderClass: 'border-dark',
      borderHighContrastClass: 'cstm_border_black',
      cardBgClass: 'cstm_card-dark',
      dropdownClass: 'dropdown-menu-dark',
      listGroupClass: 'cstm_list-group_dark',
      navbarClass: 'cstm_navbar-dark navbar-dark bg-dark text-white',
      textClass: 'text-white',
      textMutedClass: 'text-white-50',
    };
  } else {
    theme = {
      mode: 'light',
      // CSS Classes
      bgClass: '',
      borderClass: '',
      borderHighContrastClass: '',
      cardBgClass: '',
      dropdownClass: '',
      listGroupClass: '',
      navbarClass: 'navbar-light bg-white',
      textClass: '',
      textMutedClass: 'text-muted',
    };
  }
  return theme;
}

/**
 * @constant ThemeContext - Creates React Context for theming
 */
export const ThemeContext = createContext(null);
